import { styled } from "@mui/material/styles";
import { ListItemButton, Box, Typography, Avatar } from "@mui/material";
import { APP_COLORS, APP_FONT_FAMILIES } from "../../../enums";
import FlexBox from "../Flexbox";

export const SidebarMenuItem = styled(ListItemButton)({
  borderRadius: 0,
  color: APP_COLORS.primaryLight,
  transition: "all 0.2s ease",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: "transparent",
  },
  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
});

export const SidebarMenuContent = styled(FlexBox)({
  flexDirection: "column",
  alignItems: "center",
  gap: 4,
});

export const SidebarIconContainer = styled(Avatar)({
  width: "40px",
  height: "40px",
  backgroundColor: "transparent",
  border: "1px solid transparent",
  "& svg": {
    color: APP_COLORS.primaryLight4,
    fill: APP_COLORS.primaryLight4,
  },
  "& svg path": {
    fill: APP_COLORS.primaryLight4,
    stroke: APP_COLORS.primaryLight4,
  },
});

export const ActiveSidebarIconContainer = styled(SidebarIconContainer)({
  background: APP_COLORS.headerDivider,
  border: `1px solid ${APP_COLORS.primaryLight4}`,
  width: "40px",
  height: "40px",
  "& svg": {
    color: APP_COLORS.primaryLight,
    fill: APP_COLORS.primaryLight,
  },
  "& svg path": {
    fill: APP_COLORS.primaryLight,
    stroke: APP_COLORS.primaryLight,
  },
});

export const SidebarMenuText = styled(Typography)({
  textAlign: "center",
  color: APP_COLORS.primaryLight4,
  width: "80px",
  fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
});

export const ActiveSidebarMenuText = styled(SidebarMenuText)({
  color: APP_COLORS.primaryLight,
  fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
});
